import {
  AdminCertificate,
  ApiResponse,
  CreateCertificateRequest,
  PaginationParams,
  UpdateCertificateRequest,
} from "../../types/admin";
import httpClient from "../httpClient";
import { sanitizeArrayResponse } from "./helpers";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5167/api";

export const certificatesApi = {
  getAll: async (params?: PaginationParams): Promise<ApiResponse<AdminCertificate[]>> => {
    const response = await httpClient.get<AdminCertificate[]>("/certificates", params);
    return sanitizeArrayResponse(response);
  },

  getById: (id: string | number): Promise<ApiResponse<AdminCertificate>> =>
    httpClient.get(`/certificates/${id}`),

  create: async (data: CreateCertificateRequest, file?: File, issuerLogo?: File): Promise<ApiResponse<AdminCertificate>> => {
    const formData = new FormData();
    formData.append("Name", data.name);
    formData.append("DescriptionPt", data.descriptionPt);
    formData.append("DescriptionEn", data.descriptionEn);
    formData.append("IssuerName", data.issuerName);
    formData.append("IssueDate", data.issueDate);
    if (data.expirationDate) formData.append("ExpirationDate", data.expirationDate);
    formData.append("CredentialId", data.credentialId);
    formData.append("CredentialUrl", data.credentialUrl);
    if (file) formData.append("File", file);
    if (issuerLogo) formData.append("IssuerLogo", issuerLogo);
    if (data.displayOrder != null) formData.append("DisplayOrder", data.displayOrder.toString());
    return httpClient.postFormData("/certificates", formData);
  },

  update: async (id: string | number, data: UpdateCertificateRequest, file?: File, issuerLogo?: File): Promise<ApiResponse<AdminCertificate>> => {
    const formData = new FormData();
    formData.append("Name", data.name);
    formData.append("DescriptionPt", data.descriptionPt);
    formData.append("DescriptionEn", data.descriptionEn);
    formData.append("IssuerName", data.issuerName);
    formData.append("IssueDate", data.issueDate);
    if (data.expirationDate) formData.append("ExpirationDate", data.expirationDate);
    formData.append("CredentialId", data.credentialId);
    formData.append("CredentialUrl", data.credentialUrl);
    if (file) formData.append("File", file);
    if (issuerLogo) formData.append("IssuerLogo", issuerLogo);
    if (data.displayOrder != null) formData.append("DisplayOrder", data.displayOrder.toString());
    return httpClient.putFormData(`/certificates/${id}`, formData);
  },

  delete: (id: string | number): Promise<ApiResponse<void>> =>
    httpClient.delete(`/certificates/${id}`),

  getDownloadUrl: (id: string | number): string =>
    `${API_BASE_URL}/certificates/${id}/download`,

  getIssuerLogoUrl: (id: string | number): string =>
    `${API_BASE_URL}/certificates/${id}/issuer-logo`,
};
